export const jalaliToday = () => new Date().toLocaleDateString('fa-IR-u-nu-latn', {
    year: 'numeric', month: '2-digit', day: '2-digit', formatMatcher: 'basic',
});

/** @returns {'missing'|'overdue'|'soon'|'ok'} */
export const depositBucket = (dateStr) => {
    if (!dateStr) return 'missing';
    const d = String(dateStr).split(' ')[0];
    const today = jalaliToday();
    if (d < today) return 'overdue';
    try {
        const [ty, tm, td] = today.split('/').map(Number);
        const [dy, dm, dd] = d.split(/[/\-]/).map(Number);
        const diff = (dy * 365 + dm * 30 + dd) - (ty * 365 + tm * 30 + td);
        if (diff >= 0 && diff <= 7) return 'soon';
    } catch (e) { /* ignore */ }
    return 'ok';
};

export const guestStayDateIssue = (characteristic) => {
    const start = characteristic?.startDate || characteristic?.timePeriod?.startDate;
    const end = characteristic?.endDate || characteristic?.timePeriod?.endDate;
    const missingStart = !String(start || '').trim();
    const missingEnd = !String(end || '').trim();
    if (missingStart && missingEnd) return 'both';
    if (missingStart) return 'start';
    if (missingEnd) return 'end';
    return null;
};
